import { FC } from 'react'

import { Button, IconArrowUpRight, Link } from '@sequencehq/core-components'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { syncErrorExternalUrl } from './integrationSyncErrorLink'
import { serviceLabel } from './integrationSyncErrorMessages'
import { SyncErrorTaskInput } from './types'

const HEADER_TEST_ID =
  'watchtower.notification.integrationSyncError.viewInIntegration'

export const ViewInIntegrationAction: FC<{
  taskId: string
  fullWidth?: boolean
  'data-testid'?: string
}> = ({ taskId, fullWidth, 'data-testid': dataTestId = HEADER_TEST_ID }) => {
  const { manualTask } = useManualTask({ taskId })
  const input = manualTask?.input as SyncErrorTaskInput | undefined
  const externalUrl = input ? syncErrorExternalUrl(input) : undefined

  if (!input || !externalUrl) {
    return null
  }

  return (
    <Button
      as={Link.Unstyled}
      to={externalUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="secondary"
      fullWidth={fullWidth}
      leadingIcon={<IconArrowUpRight />}
      data-testid={dataTestId}
    >
      View in {serviceLabel(input.externalService)}
    </Button>
  )
}
